
import React from 'react';
import { CountryItem } from './types';
import { MobileCountryList } from './table/MobileCountryList';
import { DesktopCountryTable } from './table/DesktopCountryTable';
import { CountriesPagination } from './CountriesPagination';

interface CountryTableProps {
  countries: CountryItem[];
  editing: string | null;
  editData: CountryItem | null;
  onEdit: (country: CountryItem) => void;
  onSave: () => void;
  onDelete: (id: string) => void;
  onToggleActive: (id: string) => void;
  onEditDataChange: (data: CountryItem) => void;
  onOpenDialog: (country: CountryItem) => void;
  isMobile?: boolean;
  // Pagination props
  currentPage: number;
  totalPages: number;
  itemsPerPage: number;
  totalItems: number;
  onPageChange: (page: number) => void;
  onItemsPerPageChange: (itemsPerPage: number) => void;
}

export const CountryTable = ({
  countries,
  editing,
  editData,
  onEdit,
  onSave,
  onDelete,
  onToggleActive,
  onEditDataChange,
  onOpenDialog,
  isMobile,
  currentPage,
  totalPages,
  itemsPerPage,
  totalItems,
  onPageChange,
  onItemsPerPageChange,
}: CountryTableProps) => {
  return (
    <div className="space-y-4">
      {isMobile ? (
        <MobileCountryList
          countries={countries}
          editing={editing}
          editData={editData}
          onEditDataChange={onEditDataChange}
          onToggleActive={onToggleActive}
          onSave={onSave}
          onDelete={onDelete}
          onOpenDialog={onOpenDialog}
        />
      ) : (
        <DesktopCountryTable
          countries={countries}
          editing={editing}
          editData={editData}
          onEditDataChange={onEditDataChange}
          onSave={onSave}
          onDelete={onDelete}
          onToggleActive={onToggleActive}
          onOpenDialog={onOpenDialog}
        />
      )}
      
      <CountriesPagination
        currentPage={currentPage}
        totalPages={totalPages}
        itemsPerPage={itemsPerPage}
        totalItems={totalItems}
        onPageChange={onPageChange}
        onItemsPerPageChange={onItemsPerPageChange}
      />
    </div>
  );
};
